// Share overlapping reads within one Redux store. Settled results are not
// cached: later navigation, polling and explicit refresh still fetch new data.
const pendingByScope = new WeakMap()

export function sharePendingRead(scope, keyParts, load, { force = false } = {}) {
  let pending = pendingByScope.get(scope)
  if (!pending) { pending = new Map(); pendingByScope.set(scope, pending) }
  const key = JSON.stringify(keyParts)
  if (!force && pending.has(key)) return pending.get(key)
  const request = Promise.resolve().then(load)
  pending.set(key, request)
  const clear = () => { if (pending.get(key) === request) pending.delete(key) }
  request.then(clear, clear)
  return request
}
